import './DsRoot.scss';
import React from 'react';

import { cn } from 'src/component/ds/utils';

/** Exported so portal-based components can apply it to their portal content. */
export const DS_ROOT_CLASS = 'ds-root';

export interface DsRootProps {
  children?: React.ReactNode;
  className?: string;
}

/** Every design-system surface must render inside this. */
export default function DsRoot ({ children, className }: DsRootProps) {
  return (
    <div className={cn(DS_ROOT_CLASS, className)} data-testid='ds-root'>{children}</div>
  );
}
